import React from "react";
import classNames from "classnames";

export type TabPropsType = {
    currentTab: string|number|symbol,
    tabName: string|number|symbol,
    tabLabel?: any,
    onClick?: (e: React.MouseEvent, tabName: string|number|symbol) => void,
    className?: string|string[]|Record<string, any>,
    disabled?: any,
}

export default class Tab extends React.Component<TabPropsType> {

    render() {
        return (
            <li
                className={classNames("nav-item", {active: this.props.tabName !== undefined && this.props.currentTab === this.props.tabName, disabled: this.props.disabled}, this.props.className)}
            >
                <a
                    href="#"
                    className={classNames("nav-link", {active: this.props.tabName !== undefined && this.props.currentTab === this.props.tabName, disabled: this.props.disabled})}
                    onClick={(e) => {
                        e && e.preventDefault();
                        if(this.props.onClick && !this.props.disabled) {
                            this.props.onClick(e, this.props.tabName);
                        }
                    }}
                >
                    {this.props.children}
                </a>
            </li>
        );
    }
}